import React from 'react'
import { useTranslation } from 'react-i18next'
import { importColumnLabel, importErrorText } from '../lib/errors'
import type { CostImportError } from '../types'

const MAX_SHOWN_ERRORS = 200

/** The rows a spreadsheet import refused: row, column and reason, the first MAX_SHOWN_ERRORS of them. */
const ImportErrorsTable: React.FC<{ errors: CostImportError[] }> = ({ errors }) => {
  const { t } = useTranslation()
  return (
    <>
      <div className="max-h-72 overflow-auto rounded-md border">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 text-left">
            <tr>
              <th className="w-24 p-2">{t('CostControl_import_col_row')}</th>
              <th className="w-40 p-2">{t('CostControl_import_col_column')}</th>
              <th className="p-2">{t('CostControl_import_col_error')}</th>
            </tr>
          </thead>
          <tbody>
            {errors.slice(0, MAX_SHOWN_ERRORS).map((e, i) => (
              <tr key={i} className="border-t align-top">
                <td className="p-2 tabular-nums">{e.rowNumber > 0 ? e.rowNumber : t('CostControl_import_whole_file')}</td>
                <td className="p-2">{importColumnLabel(e.column, t)}</td>
                <td className="p-2">{importErrorText(e, t)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {errors.length > MAX_SHOWN_ERRORS && <p className="text-xs text-muted-foreground">{t('CostControl_import_errors_truncated', { total: errors.length })}</p>}
    </>
  )
}
export default ImportErrorsTable
